import { injectable, inject } from 'inversify';
import { ok, err, Result } from '../../../tracking-api';
import * as Common from '../../../common';
import { XApiClient } from '../client';

interface XApiSuspendDataStoreError {
  code: XApiSuspendDataStoreErrorCode;
  details: unknown;
}

function error(code: XApiSuspendDataStoreErrorCode, details: unknown) {
  return err({ code, details });
}

type XApiSuspendDataStoreErrorCode = 'query-error' | 'update-error';

@injectable()
export class XApiSuspendDataStore<T extends { [key: string]: any }>
      implements Common.SuspendDataStore<T> {

        constructor(
          @inject(XApiClient)
          private client: XApiClient) {
        }

        public async get(key: keyof T): Promise<Result<T[keyof T] | null, XApiSuspendDataStoreError>> {
          const result = await this.client.loadState(key as string);
          if (!result.success) {
            return error('query-error', result.error);
          }

          return ok(result.value as T[keyof T]);
        }

        public async get2(key: keyof T): Promise<Result<T[keyof T] | null, Common.SuspendDataStoreError>> {
          const result = await this.client.loadState(key as string);
          if (!result.success) {
            return err({ code: 'sync-error', details: result.error })
          }

          return ok(result.value as T[keyof T]);
        }

        public async update(key: keyof T, data: T[keyof T]): Promise<Result<true, XApiSuspendDataStoreError>> {

          const result = await this.client.saveState(key as string, data);
          if (!result.success) {
            return error('update-error', result.error);
          }

          return ok(true);
        }

        public async update2(aspect: keyof T,
                             data: T[keyof T]) {

          const result = await this.client.saveState(aspect as string, data);
          if (!result.success) {
            return err({ code: 'sync-error', details: result.error} as Common.SuspendDataStoreError)
          }

          return ok(true as true);
        }
      }
